module.exports = __webpack_public_path__ + "static/media/google-play-badge.2a665650.svg";